<template>
  <el-form ref="form" class="mask-form" :model="form" :rules="formRules" label-width="100px">
    <el-form-item label="内容" prop="field">
      <el-select v-model="field" :disabled="form.default" placeholder="请选择要填入的内容">
        <el-option v-for="item in fields"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="X坐标" prop="x">
      <el-input v-model="form.x" type="number" :min="0"></el-input>
    </el-form-item>

    <el-form-item label="Y坐标" prop="y">
      <el-input v-model="form.y" type="number" :min="0"></el-input>
    </el-form-item>

    <!-- // 图片 -->
    <template v-if="form.type">
      <el-form-item label="图片宽度" :rules="dynimacRules.img_width">
        <el-input type="number" v-model="form.img_width"></el-input>
      </el-form-item>
      <el-form-item label="图片高度" :rules="dynimacRules.img_height">
        <el-input type="number" v-model="form.img_height"></el-input>
      </el-form-item>
    </template>
    <!-- // 文字 -->
    <template v-else>
      <el-form-item label="字号" :rules="dynimacRules.font_size">
        <el-input v-model="form.font_size" type="number" :min="12"></el-input>
      </el-form-item>
      <el-form-item label="对齐" :rules="dynimacRules.align">
        <el-radio-group v-model="form.align">
          <el-radio label="left">居左</el-radio>
          <el-radio label="center">居中</el-radio>
          <el-radio label="right">居右</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="颜色" :rules="dynimacRules.color">
        <el-color-picker v-model="form.color"></el-color-picker>
      </el-form-item>
      <el-form-item label="文字示例">
        <el-input v-model="form.demo"></el-input>
      </el-form-item>
    </template>

    <el-form-item>
      <el-button type="primary" @click="submit">确定</el-button>
      <el-button type="info" @click="cancel">取消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    name: 'MaskForm',
    model: {
      prop: 'form',
      event: 'submit',
    },
    props: {
      form: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    computed: {
      field: {
        get() {
          return this.form.field;
        },
        set(val) {
          this.form.field = val;
          this.form.type = (val == 'id_photo' || val == 'qr_code') ? 1 : 0;
        },
      },
    },
    data() {
      return {
        dynimacRules: {
          font_size: [
            {required: true, message: '字号必填', trigger: 'blur'},
          ],
          color: [
            {required: true, message: '颜色必填', trigger: 'blur'},
          ],
          img_width: [
            {required: true, message: '颜色必填', trigger: 'blur'},
          ],
          img_height: [
            {required: true, message: '颜色必填', trigger: 'blur'},
          ],
        },
        formRules: {
          field: [
            {required: true, message: '文本内容不能为空', trigger: 'blur'},
          ],
          x: [
            {required: true, message: 'X坐标不能为空', trigger: 'blur'},
          ],
          y: [
            {required: true, message: 'Y坐标不能为空', trigger: 'blur'},
          ],
          type: [
            {required: true, message: '类型不能为空', trigger: 'blur'},
          ],
        },
        fields: [
          {
            value: 'name',
            label: '姓名',
          },
          {
            value: 'gender',
            label: '性别',
          },
          {
            value: 'cert_sn',
            label: '证书编号',
          },
          {
            value: 'id_card',
            label: '身份证号',
          },
          {
            value: 'id_photo',
            label: '证书照片',
          },
          {
            value: 'company',
            label: '所在单位',
          },
          {
            value: 'title',
            label: '职称',
          },
          {
            value: 'job',
            label: '职务',
          },
          {
            value: 'training_date',
            label: '培训日期',
          },
          {
            value: 'class_hour',
            label: '课时',
          },
          {
            value: 'send_time',
            label: '发证日期',
          },
          {
            value: 'qr_code',
            label: '查询二维码',
          }
        ],
      };
    },
    methods: {
      beforeOpen() {
        this.$refs.form.clearValidate();
      },
      submit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.form.type) {
              this.form.width = this.form.img_width;
              this.form.height = this.form.img_height;
            }
            this.$emit('submit', this.form);
          }
        });
      },
      cancel() {
        this.$refs.form.clearValidate();
        this.$emit('cancel');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mask-form {
    text-align: left;
  }
</style>
